'use client';

import { usePathname } from 'next/navigation';

interface UseIsActivePathnameOptions {
  match?: 'exact' | 'startsWith';
}

export default function useIsActivePathname(
  pathname: string,
  { match = 'exact' }: UseIsActivePathnameOptions = {},
) {
  const currentPathname = usePathname();

  switch (match) {
    case 'exact':
      return currentPathname === pathname;
    case 'startsWith':
      return !!currentPathname?.startsWith(pathname);
  }
}
